/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const GearCheckingCard = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M19.9952 10.9092C19.5636 11.1535 19.3478 11.5767 19.3479 12H17.8479C17.8478 11.0677 18.3172 10.1354 19.2562 9.60383L20.2033 9.06799C20.4923 8.90438 20.5792 8.55332 20.4212 8.28528L19.5017 6.72309C19.3396 6.44788 18.971 6.34369 18.6776 6.50982L17.7304 7.04568C15.8482 8.11077 13.519 6.76567 13.519 4.64986V3.57728C13.519 3.2719 13.2643 3 12.9201 3H11.0798C10.7355 3 10.4809 3.27202 10.4809 3.57728V4.64986C10.4809 6.76539 8.15222 8.11108 6.26977 7.04586L5.32273 6.51005C5.02896 6.34372 4.66034 6.44785 4.49839 6.72272L3.57881 8.28502C3.42062 8.55363 3.50802 8.9046 3.79633 9.06784L4.74302 9.60424C6.62025 10.6667 6.62255 13.3333 4.74371 14.3969L3.79634 14.9329C3.50926 15.0953 3.42114 15.4457 3.57934 15.7145L4.49797 17.2765C4.66034 17.5516 5.029 17.6559 5.32191 17.4904L6.27002 16.9532C6.83139 16.6357 7.43262 16.5326 7.99996 16.6004V18.1229C7.68706 18.042 7.33676 18.0731 7.00841 18.2588L6.06137 18.7954C5.0687 19.3575 3.79065 19.0309 3.20561 18.038L2.28669 16.4754C1.69524 15.4707 2.05415 14.1949 3.05771 13.6274L4.00475 13.0916C4.86793 12.6029 4.86747 11.3982 4.0042 10.9097L3.05729 10.3731C2.05394 9.80505 1.69419 8.52924 2.28629 7.52383L3.20603 5.96127C3.79107 4.96832 5.0687 4.64248 6.06137 5.20452L7.00841 5.74033C7.91166 6.25153 8.98086 5.59276 8.98086 4.64986V3.57728C8.98086 2.41235 9.9387 1.5 11.0798 1.5H12.9201C14.0594 1.5 15.019 2.41061 15.019 3.57728V4.64986C15.019 5.59276 16.0884 6.25146 16.9916 5.74026L17.9385 5.20452C18.9312 4.64248 20.2091 4.96869 20.7941 5.96165L21.7136 7.52383C22.306 8.5293 21.9458 9.80514 20.9423 10.3733L19.9952 10.9092Z"
                        fill={color}
                    />
                    <path
                        d="M12 8.5C13.933 8.5 15.5 10.067 15.5 12H14C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12H8.5C8.5 10.067 10.067 8.5 12 8.5Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.5 13C9.67157 13 9 13.6716 9 14.5V20.5C9 21.3284 9.67157 22 10.5 22H20.5C21.3284 22 22 21.3284 22 20.5V14.5C22 13.6716 21.3284 13 20.5 13H10.5ZM20.5 16V14.5H10.5V16H20.5ZM10.5 20.5V17.5H20.5V20.5H10.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
